/*
 * This file is part of glowingblue/gamilytics.
 *
 * Copyright (c) 2022 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import app from 'flarum/forum/app';
import routeChanged from 'route-changed';
import { slug as extSlug } from '../common';
export default function () {
  let whitelist;
  let prevRoute;
  function registerPageVisit(route) {
    try {
      if (!whitelist) {
        try {
          const parsed = JSON.parse(app.forum.attribute(`${extSlug}.pageVisitsWhitelist`));
          if (!Array.isArray(parsed)) throw new TypeError('whitelist is not an array');
          whitelist = parsed.map(item => {
            const {
              rule
            } = item;
            const pieces = rule.split('/');
            // g/y make test() stateful through lastIndex, which would skip alternating matches of one rule.
            const options = pieces.pop().replace(/[gy]/g, '');
            pieces.shift();
            return {
              regex: new RegExp(pieces.join('/'), options),
              ...item
            };
          });
        } catch (e) {
          // Assigned here so the failure is reported once per page, not once per route change.
          whitelist = [];
          console.warn(`${extSlug}: page visit whitelist is missing or invalid, no visits will be recorded`, e);
        }
      }
      const match = whitelist.find(item => item.regex.test(route));
      if (!match?.slug) {
        return;
      }
      const {
        slug,
        regex
      } = match;

      // RegExp.source escapes '/', but tolerate either spelling so detection does not hinge on it.
      // Moving between posts of one discussion changes the route without being a new visit.
      if ((slug === 'discussion' || /\\?\/d\\?\//.test(regex.source)) && prevRoute) {
        const prevMatch = whitelist.find(item => item.regex.test(prevRoute));
        if (prevMatch?.slug === slug) {
          // The configured regex is expected to expose the discussion id as its second capture group; a rule
          // without one yields no dedup key, so the visit is recorded rather than thrown away.
          const prevId = prevRoute.match(regex)?.[2];
          const id = route.match(regex)?.[2];
          if (prevId != null && prevId === id) {
            return;
          }
        }
      }
      app.request({
        method: 'POST',
        url: `${app.forum.attribute('apiUrl')}/gamilytics/pageVisit`,
        body: {
          route,
          slug
        },
        errorHandler: () => {}
      }).catch(() => {});
      prevRoute = route;
    } catch (e) {
      // Background task: a failed visit record must never surface to the user.
    }
  }

  // Deferred past the initializer tick so the first visit records after the app has booted.
  setTimeout(() => {
    registerPageVisit(window.location.pathname);
  }, 0);
  routeChanged(route => {
    registerPageVisit(route);
  });
}